import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingInvoices: false,
  loadingInvoice: false,
  loadingGenerateRenewal: false,
  loadingPayInvoice: false,
  loadingBulkAllocate: false,
  loadingPdf: false,
  loadingEmail: false,

  errorLoadingInvoices: null,
  errorLoadingInvoice: null,
  errorGeneratingRenewal: null,
  errorPayingInvoice: null,
  errorBulkAllocate: null,
  errorLoadingPdf: null,
  errorEmailing: null,

  invoices: [],
  currentInvoice: null,
  pdfUrl: null,
  pagination: null,
  serverStatus: null,
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setLoadingInvoices: (state) => {
      state.loadingInvoices = true;
      state.errorLoadingInvoices = null;
    },
    setLoadingInvoice: (state) => {
      state.loadingInvoice = true;
      state.errorLoadingInvoice = null;
    },
    setLoadingGenerateRenewal: (state) => {
      state.loadingGenerateRenewal = true;
      state.errorGeneratingRenewal = null;
    },
    setLoadingPayInvoice: (state) => {
      state.loadingPayInvoice = true;
      state.errorPayingInvoice = null;
    },
    setLoadingBulkAllocate: (state) => {
      state.loadingBulkAllocate = true;
      state.errorBulkAllocate = null;
    },
    setLoadingPdf: (state) => {
      state.loadingPdf = true;
      state.errorLoadingPdf = null;
    },
    setLoadingEmail: (state) => {
      state.loadingEmail = true;
      state.errorEmailing = null;
    },

    setErrorLoadingInvoices: (state, { payload }) => {
      state.loadingInvoices = false;
      state.errorLoadingInvoices = payload;
    },
    setErrorLoadingInvoice: (state, { payload }) => {
      state.loadingInvoice = false;
      state.errorLoadingInvoice = payload;
    },
    setErrorGeneratingRenewal: (state, { payload }) => {
      state.loadingGenerateRenewal = false;
      state.errorGeneratingRenewal = payload;
    },
    setErrorPayingInvoice: (state, { payload }) => {
      state.loadingPayInvoice = false;
      state.errorPayingInvoice = payload;
    },
    setErrorBulkAllocate: (state, { payload }) => {
      state.loadingBulkAllocate = false;
      state.errorBulkAllocate = payload;
    },
    setErrorLoadingPdf: (state, { payload }) => {
      state.loadingPdf = false;
      state.errorLoadingPdf = payload;
    },
    setErrorEmailing: (state, { payload }) => {
      state.loadingEmail = false;
      state.errorEmailing = payload;
    },

    setInvoices: (state, { payload: { content, pagination } }) => {
      state.loadingInvoices = false;
      state.invoices = content;
      state.pagination = pagination;
    },
    setCurrentInvoice: (state, { payload }) => {
      state.loadingInvoice = false;
      state.currentInvoice = payload;
    },
    updateInvoiceSuccess: (state, { payload }) => {
      state.loadingPayInvoice = false;
      if (state.currentInvoice?.id === payload.id)
        state.currentInvoice = payload;
    },

    generateRenewalSuccess: (state, { payload }) => {
      state.loadingGenerateRenewal = false;
      state.errorGeneratingRenewal = null;
      state.invoices = [payload, ...state.invoices];
    },

    setPdfUrl: (state, { payload }) => {
      state.loadingPdf = false;
      state.pdfUrl = payload;
    },
    clearPdfUrl: (state) => {
      if (state.pdfUrl) URL.revokeObjectURL(state.pdfUrl);
      state.pdfUrl = null;
    },
    setEmailSuccess: (state) => {
      state.loadingEmail = false;
    },

    setServerResponseStatus: (state, { payload }) => {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingInvoices,
  setLoadingInvoice,
  setLoadingGenerateRenewal,
  setLoadingPayInvoice,
  setLoadingBulkAllocate,
  setLoadingPdf,
  setLoadingEmail,
  setErrorLoadingInvoices,
  setErrorLoadingInvoice,
  setErrorGeneratingRenewal,
  setErrorPayingInvoice,
  setErrorBulkAllocate,
  setErrorLoadingPdf,
  setErrorEmailing,
  setInvoices,
  setCurrentInvoice,
  generateRenewalSuccess,
  updateInvoiceSuccess,
  setPdfUrl,
  clearPdfUrl,
  setEmailSuccess,
  setServerResponseStatus,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
